import { navigationPaths } from 'data/constants';

export const getHotelPageLink = (
  hotelId: number | null,
  link: string | null
) => {
  if (hotelId === null) {
    return link!; // replace with a default link
  }

  // Replace all occurrences of :id with the hotelId
  return navigationPaths.HOTEL_PAGE_INTERNAL.replace(/:id/g, String(hotelId));
};
